import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Avatar } from '@/components/Avatar/Avatar';
import { CloseIcon } from '@/components/Icons/CloseIcon';
import { WebviewContainer } from '@/components/Message/Webview/WebviewContainer';
import styles from './WebviewModal.module.scss';
import './Portal.scss';
export const WebviewModal = ({ webview, showModal, handleCloseModal, avatar, }) => {
    const { t } = useTranslation();
    const receiveMessage = (event) => {
        const message = event.data;
        switch (message) {
            case 'closeModal':
                handleCloseModal();
                break;
        }
    };
    useEffect(() => {
        const closeModal = (event) => receiveMessage(event);
        window.addEventListener('message', closeModal);
        return () => {
            window.removeEventListener('message', closeModal);
        };
    });
    return (_jsx(ReactModal, { id: `modal${webview.action_id}`, isOpen: showModal, contentLabel: t('modal.webview'), portalClassName: "webview-modal", className: cn(styles.modalContent, styles[webview.height ? webview.height : '']), overlayClassName: styles.modalOverlay, ariaHideApp: false, parentSelector: () => document.querySelector('.appContainer'), children: _jsxs("div", { children: [_jsxs("div", { className: cn(styles.modalHeader), children: [_jsx(Avatar, { avatar: avatar, style: styles.avatar }), _jsx("div", { className: styles.modalLabel, children: webview.label }), _jsx("span", { role: "button", "aria-label": t('buttons.close'), tabIndex: 0, onClick: handleCloseModal, onKeyDown: handleCloseModal, className: styles.closeButton, children: _jsx(CloseIcon, {}) })] }), _jsx(WebviewContainer, { webview: webview })] }) }));
};
